import React from 'react';
import { ListItem, ListItemText } from 'material-ui/List';

const StartUploading = ({ data }) => {
    const payload = data.payload;
    const value = payload.value || '';
    const title = 'Iniciou carregamento da carga';

    return (
        <ListItem>
            <i className="material-icons">timer</i>
            <ListItemText primary={title} secondary={`Tempo decorrido: ${value}`} />
        </ListItem>
    );

}

export default StartUploading;



// WEBPACK FOOTER //
// ./src/components/Timeline/Activities/StartUploading.js